import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';

// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';

// Class
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-cpp-returns-confirmation',
  templateUrl: './cpp-returns-confirmation.component.html',
  styleUrls: ['./cpp-returns-confirmation.component.scss']
})
export class CppReturnsConfirmationComponent implements OnInit, AfterViewInit, OnDestroy {
  errorMsgs = new Array();
  // Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  productAllDataSource: any;
  displayedColumns: string[] = this.cppReturnsService.isReturnTypeForInnoculant ? ['checkbox', 'product', 'itemNumber', 'units', 'dumpedUnits', 'uom', 'packageSize', 'notes', 'approverNotes'] : ['checkbox', 'product', 'itemNumber', 'units', 'dumpedUnits', 'uom', 'packageSize', 'notes'];
  isParent: boolean = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  returnRequestNumber = 0;
  returnRequestId = 0;
  accountEmail: string;
  readOnlyAccess = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  breadcrumbtext: string;
  marketingBrandMasterList: any[];
  onBehalfUser: any;
  onBehalfUserName: string;
  isRequestPending = true;;

  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  soldToAccount: number;
  shipToAddress: string;
  soldToaccountName: string;
  soldToaddress: string;
  shipToAcnumber: string;
  soldToAcnumber: string;
  isReturnTypeForInnoculant: boolean = false;

  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    public cppReturnsService: CppReturnsService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.cppReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);
          this.isReturnTypeForInnoculant = this.cppReturnsService.isReturnTypeForInnoculant
          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestId']) {
              this.returnRequestId = +x['returnRequestId'];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }

    this.productAllDataSource = new MatTableDataSource([]);
    this.cppReturnsService.setEditModeStatus(false);
    this.errorMsgs = new Array();
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.breadcrumbtext = 'Return Request [' + result.returnRequestNumber + ']';
      this.cppReturnsService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.cppReturnsService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;
      if (result.cppReturnsProductList && result.cppReturnsProductList.length > 0) {
        result.cppReturnsProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          if (!this.isApprovalAccess && x.lineStatus == 'PENDING') {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else if (!this.isApprovalAccess && x.lineStatus == 'APPROVED') {
            x.isIncreaseQtyDisable = true;
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.cppReturnsService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.isParent = result.isParent;
      this.cppReturnsService.setProductList(result.cppReturnsProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.cppReturnsProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.cppReturnsProductList));
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      this.cppReturnsService.setSelectedAccountNo(result.shipToAccountId);
      const approvedItem = result.cppReturnsProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }

      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
      this.shipToAddress = result.shipToAccount.address1;
      this.soldToaccountName = result.soldToAccount.accountName;
      this.soldToaddress = result.soldToAccount.address1;
      this.soldToAcnumber = result.soldToAccount.accountNumber;
      this.shipToAcnumber = result.shipToAccount.accountNumber;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.cppReturnsService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          const accountNameArr = x.userName.split(',');
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + ' ' + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;

        if (this.onBehalfUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          if (requestItem && requestItem.length > 0) {
            this.onBehalfUserName = requestItem[0].userName;
            this.accountEmail = requestItem[0].userEmail;
            this.requestedByUser = requestItem[0].userId;
          }
        }
        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  backToReturnList() {
    if (this.isReturnTypeForInnoculant) {
      this.router.navigate([`/cpp-returns/dashboard-products/Inoculant`]);
    }
    else {
      this.router.navigate([`/cpp-returns/dashboard-products`]);
    }
  }

  // On page destroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
